import React, { useState, useEffect, useRef } from 'react';
import { Table, Progress, Segment } from 'tea-component';
import { useIntl } from 'umi';
import * as echarts from 'echarts';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import {
  formatEnTimeByStr,
  fixLineData,
  sortArrDesc,
  formatEnNumber,
  computePrecentChange,
  formatP,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import NoData from '@/pages/intelligence/components/NoData';
import allColumns from './topGameClomns';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import moment from 'moment';

const { sortable } = Table.addons;

export default function TopGameList(props: any) {
  const { formatMessage } = useIntl();
  const {
    title,
    data,
    time,
    gameType,
    icon,
    needTitle,
    needSegment,
    segmentType,
    needChart,
    parentType,
    changeState,
    needIcon,
    containerId,
    source,
  } = props;

  const lineColor = [
    'rgba(55,106,231,1)',
    'rgba(62,203,255,1)',
    'rgba(79,203,135,1)',
    'rgba(255,209,116,1)',
    'rgba(237,145,66,1)',
    'rgba(233,95,106,1)',
    'rgba(207,97,172,1)',
    'rgba(129,100,205,1)',
    'rgba(101,133,247,1)',
    'rgba(160,182,250,1)',
  ];

  const [mainSegment, setMainSegment] = useState('revenue');
  const segmentOptionsGame = [
    {
      text: formatMessage({ id: 'dbi_revenue_$' }),
      value: 'revenue',
    },
    {
      text: formatMessage({ id: 'dbi_downloads' }),
      value: 'downloads',
    },
    {
      text: formatMessage({ id: 'dbi_active_users' }),
      value: 'active',
    },
  ];

  const segmentOptionsCompany = [
    {
      text: formatMessage({ id: 'dbi_revenue_$' }),
      value: 'revenue',
    },
    {
      text: formatMessage({ id: 'dbi_downloads' }),
      value: 'downloads',
    },
  ];

  const [tableData, setTableData] = useState([]);

  // 存放 mobile segment 切换的数据源
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [tableData3, setTableData3] = useState([]);

  const [trendData1, setTrendData1] = useState({});
  const [trendData2, setTrendData2] = useState({});
  const [trendData3, setTrendData3] = useState({});

  const [showLineData, setShowLineData] = useState({});

  useEffect(() => {
    if (data) {
      let data1 = [] as any;
      let data2 = [] as any;
      let data3 = [] as any;
      let lineData1 = {} as any;
      let lineData2 = {} as any;
      let lineData3 = {} as any;

      let showMAU = false;
      if (segmentType == 'game') {
        if (data.rev_tops) {
          data1 = dealTableData('rev_tops', 'rev_total', 'rev', data);
        }
        if (data.download_tops && needSegment) {
          data2 = dealTableData('download_tops', 'download_total', 'download', data);
        }
        if (gameType == 'mobile') {
          data3 = dealTableData('mau_tops', 'mau_total', 'mau', data);

          lineData1 = dealTrendData('app_trend', 'mobile_game_trends', 'rev', data);
          lineData2 = dealTrendData(
            'app_trend',
            'mobile_game_dl_trends',
            'download',
            data,
            'Downloads',
          );
          lineData3 = dealTrendData('app_trend', 'mobile_game_mau_trends', 'mau', data, 'MAU');
          showMAU = !data.rev_tops && !data.download_tops;
          // console.log('showMAU',showMAU);

          if (showMAU) {
            setMainSegment('active');
          } else {
            setMainSegment('revenue');
          }
        } else if (gameType == 'pc') {
          // dealTrendData
          lineData1 = dealTrendData('pc_trend', 'pc_game_trends', 'rev', data);
        } else if (gameType == 'console') {
          lineData1 = dealTrendData('console_trend', 'console_game_trends', 'rev', data);
        }
      } else if (segmentType == 'company') {
        if (data.company_rev) {
          data1 = dealTableData('company_rev', 'company_rev_total', 'rev', data);
        }
        if (data.companies_dl && needSegment) {
          data2 = dealTableData('companies_dl', 'company_dl_total', 'download', data);
        }
        if (parentType == 'mobile') {
          lineData1 = dealTrendData('company_trend', 'mobile_company_trends', 'rev', data);
          lineData2 = dealTrendData(
            'company_trend',
            'mobile_company_dl_trends',
            'download',
            data,
            'Downloads',
          );
        } else if (parentType == 'pc') {
          lineData1 = dealTrendData('company_trend', 'pc_game_trends', 'rev', data);
        } else if (parentType == 'console') {
          lineData1 = dealTrendData('company_trend', 'console_game_trends', 'rev', data);
        }
      } else if (segmentType == 'total') {
        if (gameType == 'mobile') {
          const obj = dealTableData('mobile_tops', 'mobile_total', 'rev', data) as any;
          data1 = obj.data;
          lineData1 = dealTrendData('mobile_game_trend', 'mobile_game_trends', 'rev', data, obj.id);
        } else if (gameType == 'pc') {
          const obj = dealTableData('pc_tops', 'pc_total', 'rev', data) as any;
          data1 = obj.data;
          lineData1 = dealTrendData('pc_game_trend', 'pc_game_trends', 'rev', data, obj.id);
        } else if (gameType == 'console') {
          const obj = dealTableData('console_tops', 'console_total', 'rev', data) as any;
          data1 = obj.data;
          lineData1 = dealTrendData(
            'console_Game_trend',
            'console_game_trends',
            'rev',
            data,
            obj.id,
          );
        } else if (gameType == 'company') {
          const obj = dealTableData('companies_tops', 'company_total', 'rev', data) as any;
          data1 = obj.data;
          lineData1 = dealTrendData('company_trend', 'pc_game_trends', 'rev', data, obj.id);
        }
      } else if (segmentType == 'insight') {
        data1 = data;
      }
      setTableData1(data1);
      setTableData2(data2);
      setTableData3(data3);
      setTableData(gameType == 'mobile' && showMAU ? data3 : data1);
      setTrendData1(lineData1);
      setTrendData2(lineData2);
      setTrendData3(lineData3);
      setShowLineData(gameType == 'mobile' && showMAU ? lineData3 : lineData1);
      const xAxias = gameType == 'mobile' && showMAU ? lineData3.xAxis : lineData1.xAxis;
      const lineData = gameType == 'mobile' && showMAU ? lineData3.data : lineData1.data;
      xAxias.length > 0 && lineChartRander(xAxias, lineData);
    }
  }, [data]);

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  const resizeHandler = () => {
    const id = `mpTopGameListChart${segmentType}${gameType}`;
    const mapChartDom = document.getElementById(containerId);
    if (mapChartDom) {
      const myMapChart = echarts.init(mapChartDom);
      try {
        myMapChart.resize();
      } catch (e) {}
    }
    if (id == 'mpTopGameListChartcompanycompany') {
      specialDeal();
    }
  };

  const specialDeal = () => {
    const mapChartDom = document.getElementById('mpTopGameListChartTotalMobile');
    if (mapChartDom) {
      const myMapChart = echarts.init(mapChartDom);
      try {
        myMapChart.resize();
      } catch (e) {}
    }
  };

  const lineChartRander = (xAxis: any, data: any, tag = 'revenue') => {
    const chartDom = document.getElementById(containerId);
    if (chartDom) {
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart == null) {
        myChart = echarts.init(chartDom);
      }
      const lineFormatterTooltip = (params: any) => {
        const titleNow = segmentOptionsGame?.find((item: any) => item.value === tag).text;
        return ChartBubble({
          data: params?.sort(sortArrDesc('value')),
          headerLeftTitle: '',
          titleNow,
          topChartsType: 'marketProfile-line',
          imageType: 'mobile',
          chartType: 'line',
          dateType: 'month',
          ifNoBarImg: true,
        });
      };
      const option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          padding: 0,
          borderWidth: 0,
          appendToBody: true,
          position(pos, params, dom, rect, size) {
            const obj = { bottom: pos[1] - 20 };
            if (pos[0] + 20 + size.contentSize[0] > size.viewSize[0]) {
              obj.left = pos[0] - 20 - size.contentSize[0];
            } else if (pos[0] - 20 - size.contentSize[0] < 0) {
              obj.left = pos[0] + 20;
            }
            return obj;
          },
          formatter: lineFormatterTooltip,
          backgroundColor: 'rgba(0,0,0,0)',
        },
        legend: {
          show: true,
          bottom: 0,
          lineStyle: {
            opacity: 0,
          },
          icon: 'circle',
          type: 'scroll',
          itemWidth: 8,
        },
        grid: {
          top: '3%',
          left: '0%',
          right: '0%',
          bottom: '15%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: xAxis,
            axisTick: { alignWithLabel: true },
            axisLine: {
              color: 'rgba(0,0,0,0.45)',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: 'rgba(0,0,0,0.45)',
              formatter(value, index) {
                return formatNum(value);
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: '#E9E9E9',
              },
            },
          },
        ],
        series: data,
      };
      option && myChart.setOption(option, true);
      myChart.resize();
    }
  };

  // data1 = dealTableData('rev_tops', 'rev_total', 'rev', data);
  const dealTableData = (target: string, targetTotal: string, subTarget: string, allData: any) => {
    if (segmentType == 'total' && allData?.length >= 5) {
      allData = allData.slice(0, 5);
    }
    let top5Id = [] as any;
    const targetList = allData[target];
    const targetListTotal = allData[targetTotal] || 0;
    const retList = [] as any;
    if (targetList) {
      targetList.map((item: any, index: number) => {
        const { genre } = item;
        let genreArr = [];
        if (genre) {
          genreArr = genre.replace(/,/g, '|').split('|');
        }
        const precentChange = computePrecentChange(item[subTarget], item[`pre_${subTarget}`]);
        const temp = {
          rank: index + 1,
          list: {
            img: item.cover,
            title: item.name,
            icon: item.country_img,
            text: item.publisher,
            subtextlist: item.genre?.split(','),
          },
          name: item.name,
          gameIcon: item.cover,
          companyIcon: item.cover,
          conutryName: item.location_country,
          conutryFlag: item.country_img,
          desc: item.publisher,
          revenue: item[subTarget],
          precent: targetListTotal == 0 ? 0 : item[subTarget] / targetListTotal,
          id: item.app_id || item.uuid,
          platList: item.platform ? item.platform?.split('|') : [],
          genre: genreArr?.length > 0 ? genreArr[0] : null,
          sub_genre: genreArr?.length > 1 ? genreArr[1] : null,
          precentChange,
        };
        retList.push(temp);
        top5Id.push(item.app_id || item.uuid);
      });
    }
    top5Id = top5Id.filter((item, index) => top5Id.indexOf(item) === index);
    if (segmentType == 'total') {
      const obj = {
        data: retList,
        id: top5Id,
      };
      return obj;
    }
    return retList;
  };

  /**
   * 处理趋势图数据
   * @param {*} target 趋势图数据 key
   * @param {*} subTarget 数据集合 key
   * @param {*} valueTarget 数据 key
   * @param {*} allData 要处理的数据
   */
  // lineData1 = dealTrendData('app_trend', 'mobile_game_trends', 'rev', data);
  const dealTrendData = (
    target: string,
    subTarget: string,
    valueTarget: string,
    allData: any,
    selectkey = [],
    tag = 'Revenue',
  ) => {
    const returnData = {
      xAxis: [],
      data: [],
    };
    const targetList = allData[target];
    let xAxias = [] as any;
    const tempData = {} as any;
    const data = [] as any;
    if (targetList && targetList.length > 0) {
      targetList.map((item: any, index: number) => {
        const subData = item[subTarget];
        if (subData && subData.length > 0) {
          subData.map((obj: any) => {
            const appId = obj.app_id || obj.id || obj.uuid;
            const objName = obj.name;
            const value = Math.floor(obj[valueTarget]);
            const appIdValues = tempData[appId] || {};
            const appIdData = appIdValues.data || [];
            if (appId != '') {
              appIdValues.name = objName;
              if (segmentType == 'total') {
                // total 需要对照 top5 的 id 取相应游戏趋势数据
                if (selectkey.indexOf(appId) != -1) {
                  fixLineData(appIdData, index);
                  appIdData.push(value == 0 ? '-' : value);
                  appIdValues.data = appIdData;
                  tempData[appId] = appIdValues;
                  // xAxias.push(formatEnTimeByStr(item['date'], false));
                }
              } else {
                fixLineData(appIdData, index);
                appIdData.push(value == 0 ? '-' : value);
                appIdValues.data = appIdData;
                tempData[appId] = appIdValues;
              }
            }
          });
        }
        xAxias.push(moment(item.date).format('YYYY-MM'));
      });
    }
    xAxias = xAxias.filter((item: any, index: number) => xAxias.indexOf(item) === index);
    Object.keys(tempData)?.map((item, index) => {
      const tmpData = tempData[item];
      const obj = {
        name: tmpData.name,
        type: 'line',
        color: lineColor[index],
        data: tmpData.data,
      };
      data.push(obj);
    });

    returnData.xAxis = xAxias;
    returnData.data = data;
    return returnData;
  };

  // 地图数据重新渲染
  const onSegmentChange = (value: any) => {
    setMainSegment(value);
    if (value == 'revenue') {
      setTableData(tableData1);
      setShowLineData(trendData1);
      lineChartRander(trendData1.xAxis, trendData1.data, 'revenue');
    } else if (value == 'downloads') {
      setTableData(tableData2);
      setShowLineData(trendData2);
      lineChartRander(trendData2.xAxis, trendData2.data, 'downloads');
    } else if (value == 'active') {
      setTableData(tableData3);
      setShowLineData(trendData3);
      lineChartRander(trendData3.xAxis, trendData3.data, 'active');
    }
  };

  return (
    <CardSlot
      className="tabdetails-card1"
      iconList={null}
      title={
        <div className="tabdetails-gamehead">
          <div className="tabdetails-gamehead-title">{title}</div>
          <div className="tabdetails-gamehead-text">{time}</div>
        </div>
      }
    >
      {needSegment ? (
        <div className="mpTopGameListSegment">
          <Segment
            value={mainSegment}
            defaultValue={mainSegment}
            onChange={(value) => onSegmentChange(value)}
            options={
              segmentType == 'game'
                ? segmentOptionsGame
                : segmentType == 'company'
                ? segmentOptionsCompany
                : []
            }
          />
        </div>
      ) : (
        <></>
      )}
      <div style={{ height: 260 }}>
        {needChart && showLineData?.xAxis?.length === 0 ? (
          <div style={{ height: '100%' }}>
            <NoData title="No trends data under current selections." />
          </div>
        ) : (
          <></>
        )}
        {needChart ? (
          <div className="tabdetails-echarts" id={containerId} style={{ height: '100%' }} />
        ) : (
          <></>
        )}
      </div>
      {needChart && tableData.length === 0 ? (
        <div style={{ height: 350 }}>
          <NoData title="No trends data under current selections." />
        </div>
      ) : (
        <Table
          className="tabdetails-table"
          bordered="all"
          records={[...tableData].sort(sortable.comparer([]))}
          columns={allColumns({ id: containerId, mainSegment, source })}
          addons={[]}
        />
      )}
    </CardSlot>
  );
}
